import Tooltip from "../ui/ToolTip";

export default function ChipInfo(text) {
  
  const textMap = {
    "Admin": "Este campo debe ser llenado por el administrador.",
    "Asistente": "Este campo debe ser llenado por el asistente de administración.",
    "Especialista": "Este campo debe ser llenado por el especialista responsable del servicio.",
    "Sistema": "Este campo se llena automáticamente por el sistema.",
  }

  const textColorMap = {
    "Admin": "bg-blue-200",
    "Asistente": "bg-green-200",
    "Especialista": "bg-yellow-200",
    "Sistema": "bg-gray-200",
  }

  return (
    <Tooltip content={textMap[text]}>
      <div className={`px-2 ${textColorMap[text]} rounded-md hover:cursor-pointer`}>
        <span className="font-light text-[10px]">{text}</span>
      </div>
    </Tooltip>
  )
}